export const fr = {
  // Navigation
  nav: {
    home: 'Accueil',
    findHairstylist: 'Recherche',
    forum: 'Le forum des filles',
    about: 'À propos',
  },
  // Header
  header: {
    account: 'Compte',
    connected: 'Connectée',
    hairstylistAccount: 'Compte coiffeuse',
    clientAccount: 'Compte client',
    viewProfile: 'Voir mon profil coiffeuse',
    favorites: 'Mes favoris',
    reviews: 'Mes avis',
    myPosts: 'Mes questions',
    favoritePosts: 'Mes questions favorites',
    accountSettings: 'Mon compte',
    logout: 'Déconnexion',
    login: 'Connexion',
    signup: 'Inscription',
    addHairstylist: 'Ajouter un profil de coiffeuse',
    messages: 'Messages',
    iAmProvider: "J'offre un service",
    dashboard: 'Tableau de bord',
    manageSubscription: 'Gérer mon abonnement',
    verifyEmail: 'Vérifier un email',
    pendingEmails: 'Emails en attente',
    dashboardAnalytics: 'Dashboard Analytics',
    chooseProviderType: 'Choisissez votre type de prestation',
    editProfile: 'Modifier mon profil',
    upgradeToPro: 'Passer en mode PRO',
  },
  // Home Page
  home: {
    heroTitle: 'Trouve ta',
    heroAfro: 'coiffeuse afro',
    heroClicks: 'en 3 clics',
    heroSubtitle: 'Simple. Rapide. Efficace.',
    findButton: 'Je cherche une pro de la beauté !',
    signupButton: "J'offre un service, je m'inscris !",
    checking: 'Vérification...',
    lastProfiles: 'Derniers profils créés',
    loading: 'Chargement...',
    mockupAlt: "Aperçu de l'application",
    existingProfileTitle: 'Tu as déjà un profil coiffeuse ✨',
    existingProfileMessage: "Ton compte est déjà associé à un profil dans l'annuaire. Tu peux le consulter et le modifier directement.",
    viewMyProfile: 'Voir mon profil',
    close: 'Fermer',
    statsText: '120+ coiffeuses afro référencées • La plus grande base en Belgique',
    statsTextMobile: '120+ coiffeuses afro référencées en Belgique',
    newBadge: 'Nouveau sur Chérie Coiffer',
    newBadgeAriaLabel: 'Aller à la section nouveau sur Chérie Coiffer',
    providerHair: 'Coiffure',
    providerNails: 'Ongles',
    providerMakeup: 'Maquillage',
    providerEyelash: 'Cils',
    providerSale: 'Vente',
    selectProviderType: 'Quel type de prestation proposes-tu ?',
  },
  // Search Page
  search: {
    title: 'Trouver une coiffeuse',
    filters: 'Filtres',
    sort: 'Trier',
    sortBy: 'Trier par',
    ascending: 'Croissant',
    descending: 'Décroissant',
    photosAvailable: 'Photos dispo',
    country: 'Pays',
    allCountries: 'Tous les pays',
    noCountryFound: 'Aucun pays trouvé',
    belgium: 'Belgique',
    france: 'France',
    switzerland: 'Suisse',
    city: 'Ville',
    cityPlaceholder: 'Rechercher une ville...',
    name: 'Nom de la coiffeuse',
    namePlaceholder: 'Rechercher par nom...',
    services: 'Prestations',
    categories: 'Catégories',
    kidsAccepted: 'Accepte les enfants',
    menAccepted: 'Accepte les hommes',
    canTravel: 'Peut se déplacer',
    hasPhotos: 'Avec photos',
    results: 'résultats',
    noResults: 'Aucun résultat trouvé',
    clearFilters: 'Réinitialiser les filtres',
    apply: 'Appliquer',
    close: 'Fermer',
    generalInfo: 'Informations générales',
    sortByDistance: 'Distance',
    sortByRating: 'Note',
    sortByUpdated: 'Dernière mise à jour',
    sortByCreated: 'Date de création',
    refineSearch: 'Affiner la recherche',
    searchByCityService: 'Rechercher par ville, service...',
    searching: 'Recherche en cours…',
    removeCity: 'Retirer {city}',
    coiffesChildren: 'Coiffe les enfants',
    coiffesMen: 'Coiffe les hommes',
    canTravelLabel: 'Peut se déplacer',
    photosAvailableLabel: 'Photos disponibles',
    sortDefault: 'Par défaut',
    sortDistance: 'Distance',
    sortRating: 'Notes',
    sortAlphabetical: 'Ordre alphabétique',
    sortCreatedAt: 'Date de création',
    sortAscending: 'Trier par ordre croissant',
    sortDescending: 'Trier par ordre décroissant',
    expand: 'Développer',
    collapse: 'Réduire',
    serviceTypes: 'Type de prestations',
    loadingCategories: 'Chargement des catégories…',
    reset: 'Réinitialiser',
    otherServices: 'Autres prestations',
    viewList: 'Liste',
    viewMap: 'Carte',
    activeFilter: 'filtre actif',
    youAreProvider: 'Tu es {provider} ?',
    signupHere: 'Inscris-toi ici.',
    found: 'trouvées',
    foundSingular: 'trouvée',
    providers: 'prestataires',
    provider: 'prestataire',
    providerRegistration: 'Inscription prestataire',
    allResultsShown: 'Vous avez tout vu ✨',
    profileNotPublished: "Ton profil n'est pas encore publié. Active ton abonnement pour être visible.",
    activateProfile: 'Activer mon profil',
  },
  // Hairstylist Card
  card: {
    canTravel: '(peut se déplacer)',
    photosAvailable: 'Photos dispos',
    photos: 'Photos',
    contact: 'Contact',
    viewProfile: 'Voir le profil',
  },
  // Hairstylist Detail
  detail: {
    back: 'Retour',
    addToFavorites: 'Ajouter aux favoris',
    removeFromFavorites: 'Retirer des favoris',
    contact: 'Contact',
    services: 'Prestations',
    description: 'Description',
    gallery: 'Galerie photos',
    reviews: 'Avis clients',
    rating: 'Note',
    noReviews: 'Aucun avis pour le moment',
    writeReview: 'Écrire un avis',
    editReview: 'Modifier mon avis',
    deleteReview: 'Supprimer mon avis',
    reviewPlaceholder: 'Écris ton avis ici...',
    submitReview: 'Publier',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    save: 'Enregistrer',
    freeProfile: 'Profil gratuit (limité)',
    proProfile: 'Profil PRO',
    emptyState: 'Sélectionne une vignette pour voir les détails',
    generalInfo: 'Informations générales',
    profileName: 'Nom du profil',
    notSpecified: 'Non spécifié',
    deleteProfile: 'Supprimer le profil',
    mainCity: 'Ville principale',
    citiesServed: 'Villes desservies',
    presentation: 'Présentation',
    coordinates: 'Coordonnées',
    primaryContact: 'Réseau social primaire',
    photos: 'Photos',
    profilePhoto: 'Photo de profil',
    galleryPhoto: 'Galerie',
    servicesOffered: 'Prestations proposées',
    loginToReview: 'Connectez-vous pour noter',
    giveReview: 'Donner mon avis',
    confirmDeleteReview: 'Êtes-vous sûr de vouloir supprimer votre avis ?',
    deleting: 'Suppression...',
    anonymousUser: 'Utilisateur anonyme',
    yourReview: '(Votre avis)',
    unknownDate: 'Date inconnue',
    identificationCode: 'Code d\'identification :',
    prevPhoto: 'Photo précédente',
    nextPhoto: 'Photo suivante',
    errorDeleteProfile: 'Erreur lors de la suppression du profil.',
    errorDelete: 'Erreur lors de la suppression',
  },
  // Posts
  posts: {
    title: 'Le forum des filles',
    subtitle: 'Ici, tu peux poser des questions, partager tes expériences, et aider les autres.',
    createPost: 'Créer une question',
    askQuestion: '+ Poser une question',
    editPost: 'Modifier la question',
    deletePost: 'Supprimer la question',
    noPosts: 'Aucune question pour le moment',
    writeComment: 'Écrire un commentaire',
    addComment: 'Ajouter un commentaire',
    commentPlaceholder: 'Écrire un commentaire...',
    publish: 'Publier',
    seeMoreComments: 'Voir les {count} commentaires précédents',
    seeLessComments: 'Voir moins',
    addPhotos: 'Ajouter des photos',
    titlePlaceholder: 'Titre de ta question',
    contentPlaceholder: 'Contenu de ta question...',
    loading: 'Chargement...',
  },
  // Profile
  profile: {
    title: 'Mon profil',
    favorites: 'Mes favoris',
    reviews: 'Mes avis',
    myPosts: 'Mes questions',
    favoritePosts: 'Mes questions favorites',
    noFavorites: 'Tu n\'as pas encore de favoris',
    noReviews: 'Tu n\'as pas encore écrit d\'avis',
    noPosts: 'Tu n\'as pas encore créé de question',
    unpublishedTitle: 'Profil non publié',
    unpublishedMessage: 'Ton profil n\'est pas encore visible sur la plateforme. Finalise ton paiement pour le publier.',
    signInToActivate: 'Connecte-toi pour activer ton profil',
    signInToActivateText: 'Tu as reçu un email pour activer ton profil. Connecte-toi pour continuer.',
    finalizePayment: 'Finaliser le paiement',
  },
  // Payment
  payment: {
    title: 'Boost ta visibilité professionnelle',
    subtitle: 'Choisis le plan qui te convient',
    freeTitle: 'Profil Gratuit',
    freeSubtitle: 'Idéal pour commencer à être visible, avec des fonctionnalités limitées.',
    proTitle: 'Profil PRO',
    proSubtitle: 'Version complète du profil, pour booster ta visibilité.',
    popular: 'Le plus populaire',
    price: '{price}/mois',
    perMonth: '/mois',
    free: 'Gratuit',
    createFree: 'Commencer gratuitement',
    activatePro: 'Activer mon abonnement',
    freeNote: 'Reste gratuit aussi longtemps que tu veux.',
    priceProtection: 'Prix prototype : tant que vous restez abonnée, votre tarif n\'augmente jamais.',
    creating: 'Création en cours...',
    redirecting: 'Redirection...',
    successTitle: 'Profil créé avec succès !',
    successMessage: 'Félicitations ! Ton profil gratuit a été créé. Tu peux maintenant commencer à être visible dans notre répertoire.',
    viewProfile: 'Voir mon profil',
    backHome: 'Retour à l\'accueil',
    errorMissingData: 'Impossible de créer le profil : les données du profil sont manquantes. Merci de reprendre l\'inscription.',
    errorPaymentData: 'Impossible de lancer le paiement : les données du profil sont manquantes. Merci de reprendre l\'inscription.',
    errorEmail: 'Impossible de lancer le paiement : l\'adresse email du compte est manquante.',
    errorCheckout: 'Erreur lors de la création de la session de paiement. Merci de réessayer.',
    errorProfileCreation: 'Erreur lors de la création du profil',
    feature1: 'Visible dans le répertoire',
    feature2: 'Nom + ville + prestations visibles',
    feature3: 'Galerie photo complète',
    feature4: 'Avis clients visibles',
    feature5: 'Note moyenne affichée',
    feature6: 'Priorité dans les résultats de recherche',
    feature7: 'Accès à un profil simple',
    feature8: 'Badge PRO vérifié',
    feature9: 'Support prioritaire',
    feature10: 'Possibilité de passer au PRO à tout moment',
    // Page 3 – Compte créé, option PRO
    successAccountCreated: 'Ton compte est bien créé ! 🎉',
    successSubtitle: 'Tu peux déjà utiliser la plateforme librement.',
    successProIntro: "Et si tu veux plus de visibilité, découvre l'option PRO :",
    proCardTitle: 'Profil PRO – 9,99 €/mois',
    proCardSubtext: 'Boost immédiat de ta visibilité',
    proFeaturePriority: 'Toujours prioritaire dans les résultats',
    proFeatureGallery: 'Galerie photos visible par toutes',
    proFeatureReviews: 'Avis & étoiles visibles',
    proFeatureDashboard: 'Tableau de bord & statistiques',
    proFeatureServices: 'Liste de prestations détaillée',
    proFeatureCancel: 'Annulable à tout moment',
    goProButton: 'Passer PRO maintenant',
    securityText: 'Paiement sécurisé (SSL & Stripe) – Aucun frais caché',
    skipUpgrade: 'Non merci, rester en FREE',
    errorProfileNotFound: "Erreur : profil non trouvé. Veuillez recommencer l'inscription.",
    errorUserNotConnected: 'Erreur : utilisateur non connecté.',
    signInToActivate: 'Connecte-toi pour activer ton profil',
    signInToActivateText: 'Tu as reçu un email pour activer ton profil. Connecte-toi avec ton compte pour continuer.',
    signIn: 'Se connecter',
    errorStripeNotConfigured: "Stripe n'est pas encore configuré. Merci de définir REACT_APP_STRIPE_PUBLISHABLE_KEY ou de remplacer STRIPE_PUBLISHABLE_KEY dans PaymentPage.jsx.",
    errorStripeInit: "Impossible d'initialiser Stripe. Vérifie que le script https://js.stripe.com/v3 est bien chargé.",
    errorRedirectStripe: 'Erreur lors de la redirection vers Stripe. Merci de réessayer.',
    // Page Subscription Success
    subscriptionActivated: 'Abonnement activé',
    subscriptionActivatedSubtitle: 'Ton profil est maintenant visible dans l\'annuaire. Les clientes peuvent te trouver, te liker et laisser leurs avis 💗',
    subscriptionActiveStatus: 'Abonnement : ACTIF',
    subscriptionDetails: 'Détails de l\'abonnement',
    plan: 'Plan :',
    professionalPlan: 'Abonnement Professionnel — 9,99 €/mois',
    autoRenewal: 'Renouvellement automatique :',
    enabled: 'Activé',
    nextInvoice: 'Prochaine facture :',
    manageSubscription: 'Gérer mon abonnement',
    nextSteps: 'Les Prochaines Étapes',
    completeProfile: 'Complète ton profil',
    completeProfileDescription: 'Ajoute plus de détails pour attirer plus de clientes',
    addPhotos: 'Ajoute des photos',
    addPhotosDescription: 'Montre tes meilleures créations dans ta galerie',
    addPhotosButton: 'Ajouter des photos',
    inviteReviews: 'Invite tes clientes à laisser un avis',
    inviteReviewsDescription: 'Partage le lien de ton profil pour recevoir des avis',
    copyReviewLink: 'Copier mon lien d\'avis',
    linkCopied: 'Lien copié dans le presse-papier !',
    communityMessage: 'Tu fais maintenant partie de la communauté Chérie Coiffer 💜',
    proudMessage: 'On est trop fiers de t\'avoir avec nous.',
    ifYouHaveQuestion: 'Si tu as une question :',
    accessStylistSpace: 'Accéder à mon Espace Coiffeuse →',
    germanMandatoryTitle1: 'Bravo, ton profil est créé !',
    germanMandatoryTitle2: 'Finalise ton inscription',
    germanMandatorySubtitle: 'Le paiement est requis pour publier ton profil sur la plateforme',
    /* Layout DE – deux cartes côte à côte */
    germanReadyTitle: "Plus qu'une étape !",
    germanReadySubtitle: 'Active ton profil pour apparaître sur la carte et être visible par les clientes.',
    germanPreviewLabel: 'C’est ainsi que les clientes te verront',
    germanProVisibility: 'Visibilité PRO',
    germanEarlyAccess: 'Prix early access. Annulable à tout moment. Aucun frais caché.',
    germanBenefitMap: 'Apparaître sur la carte des villes',
    germanBenefitSearch: 'Être trouvée par service',
    germanBenefitPhotos: 'Afficher tes photos et avis',
    germanBenefitStats: 'Accéder à tes statistiques',
    germanActivateButton: 'Activer mon profil',
    germanActivateNote: 'La plupart des coiffeuses activent en 2 minutes.',
    paywallPreviewLabel: 'Aperçu de ton profil public',
    paywallCtaGoLive: 'Activer mon profil maintenant',
    paywallPillRecommended: 'Recommandé',
    paywallMicrocopy: 'Annulable à tout moment · Aucun frais caché',
    finalizePay: 'Finaliser et payer',
    proFeatureVerifiedBadge: 'Badge PRO vérifié',
    proFeatureSearchable: 'Les clientes peuvent te trouver par ville et service',
  },
  // Account Settings
  account: {
    title: 'Mon compte',
    accountInfo: 'Mes informations',
    username: 'Nom d\'utilisateur',
    email: 'Email',
    creationDate: 'Date de création',
    actions: 'Actions',
    changePassword: 'Changer mon mot de passe',
    deleteAccount: 'Supprimer mon compte',
    subscription: 'Mon abonnement',
    subscriptionActive: 'Abonnement actif',
    subscriptionInactive: 'Aucun abonnement actif',
    deleteWarning: 'Attention',
    deleteWarningMessage: 'Si vous supprimez votre compte et que vous avez un abonnement en cours, celui-ci sera annulé et vous ne pourrez plus accéder à votre profil PRO.',
    confirmDelete: 'Confirmer la suppression',
    cancel: 'Annuler',
    passwordModal: {
      title: 'Changer mon mot de passe',
      currentPassword: 'Mot de passe actuel',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le nouveau mot de passe',
      change: 'Changer',
      cancel: 'Annuler',
    },
  },
  // Common
  common: {
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    close: 'Fermer',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    search: 'Rechercher',
    filter: 'Filtrer',
    clear: 'Effacer',
    submit: 'Envoyer',
    confirm: 'Confirmer',
    notSpecified: 'Non spécifié',
  },
  // Chat
  chat: {
    button: 'Chat',
    title: 'Chat avec nous',
    subtitle: 'Nous répondons généralement sous 24h',
    namePlaceholder: 'Votre nom',
    emailPlaceholder: 'Votre email',
    startChat: 'Commencer la conversation',
    messagePlaceholder: 'Tapez votre message...',
    emptyState: 'Commencez la conversation ! 👋',
    close: 'Fermer',
  },
  // Auth Modal
  auth: {
    login: 'Connexion',
    signup: 'Inscription',
    resetPassword: 'Réinitialiser le mot de passe',
    username: 'Pseudo',
    usernamePlaceholder: 'Ex: marie_braids78',
    email: 'Email',
    emailOrUsername: 'Email ou pseudo',
    emailPlaceholder: 'Ex: marie@example.com',
    emailOrUsernamePlaceholder: 'Ex: marie_braids78 ou marie@mail.com',
    password: 'Mot de passe',
    passwordPlaceholder: 'Au moins 6 caractères',
    confirmPassword: 'Confirmer le mot de passe',
    confirmPasswordPlaceholder: 'Retape ton mot de passe',
    forgotPassword: 'Mot de passe oublié ?',
    sendLink: 'Envoyer le lien',
    connect: 'Se connecter',
    signupButton: "S'inscrire",
    noAccount: "Pas encore de compte ? S'inscrire",
    hasAccount: 'Déjà un compte ? Se connecter',
    loading: 'Chargement...',
    sending: 'Envoi en cours...',
    resendLink: 'Renvoyer le lien',
    resetEmailSent: 'Un email de réinitialisation vient de t\'être envoyé. Merci de vérifier ta boîte mail.',
    verificationEmailResent: 'Email de vérification renvoyé ! Merci de vérifier votre boîte mail.',
    pleaseEnterEmail: 'Merci de renseigner ton adresse email.',
    usernameRequired: 'Le pseudo est obligatoire.',
    usernameInvalid: 'Le pseudo ne peut contenir que des lettres, chiffres, tirets (-), underscores (_) et points (.).',
    emailInvalid: 'L\'adresse email n\'est pas valide. Merci de saisir une adresse email correcte.',
    passwordMinLength: 'Le mot de passe doit contenir au moins 6 caractères.',
    passwordsDontMatch: 'Les mots de passe ne correspondent pas.',
    usernameTaken: 'Ce pseudo est déjà utilisé. Merci d\'en choisir un autre.',
    emailTaken: 'Cet email est déjà utilisé. Merci de te connecter ou d\'utiliser un autre email.',
    errorOccurred: 'Une erreur est survenue',
    networkError: 'Problème de connexion. Vérifiez votre connexion internet (Wi‑Fi ou données) et réessayez.',
    verificationEmailError: 'Erreur lors de l\'envoi de l\'email de vérification.',
  },
  // Language
  language: {
    french: 'Français',
    english: 'English',
    german: 'Deutsch',
    dutch: 'Nederlands',
  },
  // Signup Page
  signup: {
    alreadyHairstylistTitle: 'Tu as déjà un profil coiffeuse ✨',
    alreadyHairstylistMessage: "Ton compte est déjà associé à un profil dans l'annuaire. Tu peux le consulter ou le modifier directement.",
    viewMyProfile: 'Voir mon profil',
    welcomeTitle: 'Bienvenue, ma belle !',
    welcomeSubtitle: 'Complète ce formulaire pour rejoindre notre annuaire.',
    infoBox: 'Pas besoin de le faire parfaitement, tu auras toujours la possibilité de modifier ces infos plus tard.',
    createAccountTitle: 'Créer ton compte',
    createAccountSubtitle: 'Dernière étape : crée ton compte pour finaliser ton inscription.',
    createAccountSubtitle2: 'Ces informations te permettront de te connecter et gérer ton profil.',
    section1Title: 'Informations générales',
    section1Subtitle: 'Quelques infos pour présenter ton profil.',
    profileName: 'Nom du profil',
    profileNamePlaceholder: 'Ex: Aya Braid Studio',
    country: 'Pays',
    selectCountry: 'Sélectionner un pays',
    noCountryFound: 'Aucun pays trouvé',
    mainCity: 'Ville principale',
    mainCityPlaceholder: 'Ex: Paris',
    canTravel: 'Je peux me déplacer au domicile de la cliente',
    addCity: 'Ajoute une ville desservie',
    presentation: 'Présentation',
    presentationPlaceholder: 'Explique-nous en quelques mots ce que tu proposes...',
    section2Title: 'Coordonnées',
    section2Subtitle: 'Comment les clientes peuvent te contacter ?',
    primaryContact: 'Réseau social primaire',
    selectPrimary: 'Sélectionner',
    primaryContactHelp: 'Le réseau primaire s\'affiche sur ta vignette. Les autres moyens de contact sont visibles sur ta fiche détail.',
    section3Title: 'Photos',
    section3Subtitle: 'Ajoute un portrait et quelques réalisations (max. 6).',
    profilePhoto: 'Photo de profil',
    addPhoto: 'Ajouter photo',
    remove: 'Retirer',
    section4Title: 'Quelles prestations proposes-tu ?',
    section4Subtitle: 'Sélectionne toutes les prestations correspondantes.',
    loadingCategories: 'Chargement des catégories…',
    username: 'Pseudo',
    usernamePlaceholder: 'Ex: marie_braids78',
    email: 'Email',
    emailPlaceholder: 'Ex: marie@example.com',
    password: 'Mot de passe',
    passwordPlaceholder: 'Au moins 6 caractères',
    confirmPassword: 'Confirmer le mot de passe',
    confirmPasswordPlaceholder: 'Retape ton mot de passe',
    cancel: 'Annuler',
    next: 'Suivant',
    previous: 'Précédent',
    submitting: 'Envoi en cours…',
    continue: 'Continuer',
    validateProfile: 'Valider mon profil',
    creating: 'Création en cours…',
    createAccountAndJoin: "Créer mon compte et rejoindre l'annuaire",
    confirmCancel: 'Êtes-vous sûr de vouloir annuler votre inscription ?',
    progressStep1: 'Création du profil',
    progressStep2: 'Création du compte',
    progressStep3: 'Confirmation',
    progressStepAria: 'Étape {step}: {label}',
    validation: {
      pleaseCompleteFields: 'Merci de compléter les champs suivants : {fields}.',
      atLeastOneService: 'Au moins une prestation',
      atLeastThreePhotos: 'Au moins 3 photos de prestations',
      atLeastOneContact: 'Au moins une information de contact',
      primaryContactRequired: 'Réseau social primaire',
      confirmPasswordLabel: 'Confirmation du mot de passe',
    },
    errorLoadCategories: 'Impossible de récupérer les catégories.',
    errorCountryNotSupported: 'Ce pays n\'est pas encore supporté. Choisis une ville en Europe ou en Afrique francophone.',
    errorImagesOnlyProfile: 'Seules les images sont autorisées pour la photo de profil.',
    errorImagesOnlyGallery: 'Seules les images sont autorisées pour la galerie.',
    errorProfileCreation: 'Erreur lors de la création du profil. Merci de réessayer.',
    creatingAccount: 'Création de votre compte en cours...',
    errorEmailVerification: 'Erreur lors de la vérification de l\'email. Merci de réessayer.',
    errorGeneric: 'Une erreur s\'est produite. Merci de réessayer.',
    errorFormNotFound: 'Erreur : formulaire non trouvé. Merci de rafraîchir la page.',
    errorOccurred: 'Une erreur est survenue. Merci de réessayer.',
    contactFields: {
      instagram: 'Instagram',
      instagramPlaceholder: "Nom d'utilisateur",
      tiktok: 'TikTok',
      tiktokPlaceholder: "Nom d'utilisateur TikTok",
      whatsapp: 'WhatsApp',
      whatsappPlaceholder: 'Numéro de téléphone WhatsApp',
      phone: 'Téléphone',
      phonePlaceholder: 'Numéro de téléphone',
      externalLink: 'Lien externe',
      externalLinkPlaceholder: 'Ex: lien Calendly',
    },
  },
  // Footer
  footer: {
    navigation: 'Navigation',
    home: 'Home',
    hairstylists: 'Coiffeuses',
    posts: 'Posts',
    information: 'Informations',
    about: 'À propos',
    faq: 'FAQ',
    contact: 'Contact',
    legal: 'Mentions légales',
    refund: 'Politique de remboursement',
    followUs: 'Suivez-nous',
    instagram: 'Instagram',
    allRightsReserved: 'Tous droits réservés',
  },
  // Legal Page
  legal: {
    title: 'Mentions Légales',
    lastUpdate: 'Dernière mise à jour : 4 décembre 2025',
    editor: {
      title: '1. Éditeur du site',
      name: 'Chérie, Coiffer ?',
      editor: 'Projet édité par :',
      editorName: 'Christelle Kabemba',
      country: 'Belgique',
      email: 'Email :',
    },
    hosting: {
      title: '2. Hébergement',
      text: 'Le site est hébergé par :',
      provider: 'Firebase Hosting – Google LLC',
      address: '1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.',
    },
    purpose: {
      title: '3. Objet du site',
      description: '<strong>Chérie, Coiffer ?</strong> est un annuaire digital facilitant la recherche de coiffeuses afro en Belgique et ailleurs. L\'objectif est de regrouper, au même endroit :',
      items: [
        'des profils de coiffeuses',
        'leurs comptes Instagram / TikTok publics',
        'leurs prestations visibles publiquement',
        'leurs informations de localisation non privées',
      ],
      goal: 'Le site vise à améliorer la visibilité des coiffeuses et à simplifier la vie des clientes.',
    },
    profiles: {
      title: '4. Création des profils coiffeuses',
      public: {
        title: '4.1 Profils générés via des informations publiques',
        text: 'Afin de permettre aux clientes de découvrir plus facilement des coiffeuses actives en Belgique, certains profils peuvent être créés à partir d\'informations <strong>publiques et librement accessibles</strong>, telles que :',
        items: [
          'pseudonyme ou nom public Instagram',
          'photo de profil publique',
          'prestations visibles publiquement',
          'ville ou zone de service indiquée',
        ],
        privacy: 'Aucune information privée (adresse personnelle, numéro privé, conversations, etc.) n\'est collectée ou publiée.',
      },
      rights: {
        title: '4.2 Droit de modification, suppression et gestion du profil',
        text: 'Toute coiffeuse peut à tout moment :',
        items: [
          'demander la <strong>suppression immédiate</strong> de son profil,',
          'demander la <strong>modification</strong> de ses informations,',
          '<strong>revendiquer</strong> son profil pour le gérer personnellement.',
        ],
        contact: 'Pour cela, il suffit d\'envoyer un message à l\'adresse suivante :',
        deletion: 'La suppression sera effectuée dans les plus brefs délais, sans justification nécessaire.',
      },
    },
    accounts: {
      title: '5. Comptes utilisateurs (clientes et coiffeuses)',
      text: 'Les utilisatrices peuvent créer un compte afin de :',
      items: [
        'gérer un profil professionnel,',
        'ajouter des coiffeuses en favoris,',
        'poser des questions dans le forum,',
        'laisser des avis (si l\'option est activée).',
      ],
      responsibility: 'Chaque utilisatrice reste responsable des informations qu\'elle publie.',
    },
    data: {
      title: '6. Collecte et traitement des données',
      text1: 'Les seules données collectées automatiquement sont anonymes et statistiques (via Google Analytics ou équivalent). Aucune donnée sensible n\'est collectée.',
      text2: 'Aucune donnée ne sera vendue ou cédée.',
    },
    gdpr: {
      title: '7. Vos droits (RGPD)',
      text: 'Conformément au RGPD, vous disposez d\'un droit :',
      items: [
        'd\'accès à vos données,',
        'de rectification,',
        'd\'opposition,',
        'd\'effacement ("droit à l\'oubli").',
      ],
      contact: 'Pour toute demande :',
    },
    intellectual: {
      title: '8. Propriété intellectuelle',
      text: 'Le design, le logo, les textes et le code du site appartiennent à Chérie, Coiffer ?. Les photos de profil Instagram appartiennent à leurs propriétaires respectifs et ne sont utilisées qu\'en tant que <strong>miniatures non commerciales</strong> pour renvoyer vers leurs pages publiques.',
    },
    liability: {
      title: '9. Responsabilité',
      text: 'Chérie, Coiffer ? n\'est pas responsable de :',
      items: [
        'la qualité des services fournis par les coiffeuses,',
        'les informations incorrectes sur des profils issus de sources publiques,',
        'les décisions prises par les clientes.',
      ],
    },
    contact: {
      title: '10. Contact',
      text: 'Pour toute question ou demande concernant vos données ou votre profil :',
    },
  },
  // FAQ Page
  faq: {
    title: 'Questions Fréquentes (FAQ)',
    lastUpdate: 'Dernière mise à jour :',
    pro: {
      title: '1. Abonnement PRO',
      whatIs: {
        title: '1.1 Qu\'est-ce que l\'abonnement PRO ?',
        text: 'L\'abonnement PRO est un abonnement mensuel de <strong>9,99 €/mois</strong> qui permet aux prestataires (coiffeuses, prestataires ongles, MUA, prestataires cils) de bénéficier de fonctionnalités premium sur Chérie Coiffer.',
      },
      benefits: {
        title: '1.2 Quels sont les avantages de l\'abonnement PRO ?',
        text: 'Les prestataires PRO bénéficient de :',
        items: [
          'Visibilité accrue dans les résultats de recherche',
          'Affichage prioritaire dans les listes',
          'Statut "PRO" visible sur leur profil',
          'Accès à des statistiques détaillées',
        ],
      },
      subscribe: {
        title: '1.3 Comment souscrire à l\'abonnement PRO ?',
        text: 'Pour souscrire à l\'abonnement PRO, vous devez d\'abord créer un profil de prestataire sur Chérie Coiffer. Une fois votre profil créé, vous serez redirigé vers la page de paiement où vous pourrez choisir l\'abonnement PRO et effectuer le paiement via Stripe.',
      },
      cancel: {
        title: '1.4 Comment puis-je annuler mon abonnement PRO ?',
        text: 'Pour annuler votre abonnement PRO, veuillez nous contacter par email à',
        text2: 'en indiquant votre demande d\'annulation. Nous traiterons votre demande dans les plus brefs délais.',
        important: 'Important :',
        importantText: 'L\'annulation prendra effet à la fin de la période de facturation en cours. Vous continuerez à bénéficier des avantages PRO jusqu\'à la fin de cette période.',
      },
      paymentFailed: {
        title: '1.5 Que se passe-t-il si mon paiement échoue ?',
        text: 'En cas d\'échec de paiement, vous recevrez un email de notification. Vous disposez d\'un délai de grâce de 7 jours pour mettre à jour votre méthode de paiement. Si le paiement n\'est pas effectué dans ce délai, votre abonnement PRO sera automatiquement désactivé et votre compte repassera en mode gratuit (FREE).',
      },
      refund: {
        title: '1.6 Puis-je obtenir un remboursement ?',
        text: 'Les abonnements sont facturés mensuellement. En cas d\'annulation, vous continuerez à bénéficier des avantages PRO jusqu\'à la fin de la période de facturation en cours. Aucun remboursement partiel n\'est effectué pour la période restante.',
      },
    },
    profile: {
      title: '2. Création et gestion de profil',
      create: {
        title: '2.1 Comment créer un profil de prestataire ?',
        text: 'Pour créer un profil de prestataire, cliquez sur "Je suis prestataire" dans le menu, choisissez votre type de prestation (Coiffure, Ongles, Maquillage, Cils), puis suivez les étapes du formulaire d\'inscription.',
      },
      edit: {
        title: '2.2 Puis-je modifier mon profil après création ?',
        text: 'Oui, vous pouvez modifier votre profil à tout moment en vous connectant à votre compte et en accédant à la page de modification de votre profil.',
      },
      delete: {
        title: '2.3 Comment supprimer mon profil ?',
        text: 'Pour supprimer votre profil, contactez-nous à',
        text2: 'La suppression sera effectuée dans les plus brefs délais.',
      },
    },
    search: {
      title: '3. Recherche et filtres',
      howTo: {
        title: '3.1 Comment rechercher un prestataire ?',
        text: 'Utilisez la barre de recherche en haut de la page pour rechercher par nom, type de prestation, ou ville. Vous pouvez également utiliser les filtres avancés pour affiner votre recherche.',
      },
      city: {
        title: '3.2 Comment fonctionne le filtrage par ville ?',
        text: 'Le filtrage par ville affiche uniquement les prestataires qui ont spécifié cette ville dans leur profil (ville principale ou villes de déplacement). Les prestataires qui peuvent se déplacer mais n\'ont pas spécifié votre ville ne seront pas affichés dans les résultats.',
      },
    },
    account: {
      title: '4. Compte utilisateur',
      create: {
        title: '4.1 Comment créer un compte ?',
        text: 'Vous pouvez créer un compte en cliquant sur "Connexion" puis "S\'inscrire". Vous pouvez créer un compte en tant que cliente ou directement en tant que prestataire.',
      },
      forgotPassword: {
        title: '4.2 J\'ai oublié mon mot de passe',
        text: 'Cliquez sur "Connexion" puis sur "Mot de passe oublié" et suivez les instructions pour réinitialiser votre mot de passe.',
      },
      delete: {
        title: '4.3 Comment supprimer mon compte ?',
        text: 'Vous pouvez supprimer votre compte depuis la page "Gestion du compte" dans les paramètres de votre profil. Cette action est irréversible et supprimera toutes vos données.',
      },
    },
    reviews: {
      title: '5. Avis et évaluations',
      howTo: {
        title: '5.1 Comment laisser un avis ?',
        text: 'Pour laisser un avis, vous devez être connectée et avoir consulté le profil du prestataire. Les avis doivent être respectueux et basés sur une expérience réelle.',
      },
      edit: {
        title: '5.2 Puis-je modifier ou supprimer mon avis ?',
        text: 'Oui, vous pouvez modifier ou supprimer vos avis depuis votre page de profil dans la section "Mes avis".',
      },
    },
    support: {
      title: '6. Contact et support',
      contact: {
        title: '6.1 Comment vous contacter ?',
        text: 'Pour toute question, demande ou problème, vous pouvez nous contacter par email à',
      },
      response: {
        title: '6.2 Délai de réponse',
        text: 'Nous nous efforçons de répondre à toutes les demandes dans un délai de 48 heures ouvrées.',
      },
    },
  },
  // About Page
  about: {
    title: 'À propos',
    lastUpdate: 'Dernière mise à jour : 4 décembre 2025',
    mission: {
      title: 'Notre mission',
      text1: '<strong>Chérie, Coiffer ?</strong> est une plateforme qui facilite la recherche de coiffeuses afro en Belgique (et bientôt ailleurs). L\'idée est simple : rassembler en un seul endroit toutes les coiffeuses actives sur Instagram, TikTok ou ailleurs, afin d\'aider les clientes à trouver exactement ce qu\'elles cherchent, sans passer des heures à fouiller les réseaux sociaux.',
      text2: 'Que vous cherchiez quelqu\'un près de chez vous, une spécialiste d\'un type de tresses, ou simplement des inspirations coiffure, notre objectif est de rendre cette recherche plus simple, plus claire, et plus accessible.',
    },
    why: {
      title: 'Pourquoi ce projet ?',
      text1: 'Après plusieurs années à l\'étranger, je suis revenue vivre en Belgique et je me suis rapidement rendu compte d\'un problème : trouver une coiffeuse fiable était devenu extrêmement compliqué.',
      text2: 'Tout passe par Instagram et TikTok, mais si vous ne connaissez pas le bon <strong>@</strong>, il est facile de passer à côté d\'une coiffeuse talentueuse… parfois même celle qui habite juste à deux rues de chez vous.',
      text3: 'C\'est en tant que passionnée de digital que j\'ai décidé de créer un outil qui centralise ces informations de manière simple, claire et transparente.',
    },
    profiles: {
      title: 'Comment les profils sont créés ?',
      text1: 'Pour rendre la plateforme immédiatement utile, certaines fiches de coiffeuses sont créées à partir d\'informations <strong>publiques</strong> visibles sur leurs réseaux sociaux (pseudonyme, photos publiques, prestations affichées, etc.).',
      text2: '<strong>Chaque coiffeuse garde un contrôle total sur son profil :</strong>',
      items: [
        'revendiquer son profil pour le gérer elle-même ;',
        'faire modifier les informations ;',
        'demander la suppression immédiate du profil, sans justification.',
      ],
      text3: 'Le but n\'est jamais de remplacer les pages Instagram : simplement de les rendre plus faciles à trouver.',
    },
    name: {
      title: 'Pourquoi "Chérie, Coiffer ?"',
      text1: 'Le nom est un clin d\'œil à une phrase bien connue dans la communauté :',
      quote: '« Ma chérie, viens, je te coiffe »',
      text2: 'typique des quartiers comme Matongé, où les coiffeuses abordent les clientes.',
      text3: 'Le site reprend cet esprit : un espace chaleureux, accessible, et pensé pour nous.',
    },
    values: {
      title: 'Nos valeurs',
      items: [
        '<strong>Accessibilité :</strong> permettre à tout le monde de trouver une coiffeuse facilement.',
        '<strong>Visibilité :</strong> aider les coiffeuses talentueuses à être mieux découvertes.',
        '<strong>Transparence :</strong> les profils sont modifiables ou supprimables à tout moment.',
        '<strong>Simplicité :</strong> une plateforme claire, sans complications.',
      ],
    },
    contact: {
      title: 'Contact',
      text: 'Pour toute question, pour modifier ou revendiquer un profil, ou pour collaborer :',
    },
  },
  // Services et catégories depuis Firestore
  // Les codes correspondent aux codes dans la base de données
  // Format: services.{CODE} ou categories.{CODE}
  // Exemple: services.TRESSES_CORNBROWS = "Cornrows"
  // Si une traduction n'existe pas, le label français de la DB sera utilisé comme fallback
  services: {
    // Les traductions seront ajoutées au fur et à mesure selon les besoins
    // Pour l'instant, on utilise le label français de la DB comme fallback
  },
  categories: {
    // Les traductions seront ajoutées au fur et à mesure selon les besoins
    // Pour l'instant, on utilise le label français de la DB comme fallback
  },
};

